"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ProgressBar = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ProgressBar, _Component);

  var _super = _createSuper(ProgressBar);

  function ProgressBar() {
    (0, _classCallCheck2["default"])(this, ProgressBar);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ProgressBar, [{
    key: "render",
    value: function render() {
      var className = this.props.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.line)
      }));
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$props = this.props,
          backgroundColor = _this$props.backgroundColor,
          color = _this$props.color,
          minWidth = _this$props.minWidth,
          noRadius = _this$props.noRadius,
          transitionDurationMs = _this$props.transitionDurationMs,
          _this$props$height = _this$props.height,
          height = _this$props$height === void 0 ? 5 : _this$props$height,
          progressProp = _this$props.progress;
      var progress = Math.max(Math.min(progressProp, 1), 0);
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          minWidth: minWidth || 100,
          alignItems: "stretch",
          flexDirection: "row",
          borderRadius: noRadius ? undefined : height,
          height: height,
          backgroundColor: backgroundColor
        },
        line: {
          borderRadius: noRadius ? undefined : height,
          backgroundColor: color,
          transition: "width ".concat(transitionDurationMs, "ms linear"),
          width: "".concat(progress * 100, "%")
        }
      });
    }
  }]);
  return ProgressBar;
}(_react.Component), _class3.defaultProps = {
  transitionDurationMs: 800
}, _class3.propDoc = {
  color: {
    required: true,
    type: "string",
    description: "Color of the progress bar"
  },
  progress: {
    required: true,
    type: "string",
    description: "Fractional progress value. Should be between 0 and 1"
  },
  backgroundColor: {
    required: true,
    type: "string",
    description: "Background color of the progress bar"
  },
  minWidth: {
    required: false,
    defaultValue: "100px",
    type: "?number",
    description: "Minimum width of the progress bar"
  },
  height: {
    required: false,
    defaultValue: "5px",
    type: "?number",
    description: "Heigh of the progress bar"
  },
  noRadius: {
    required: false,
    type: "boolean",
    description: "Indicates that the border radius should be hidden"
  },
  transitionDurationMs: {
    required: false,
    type: "boolean",
    description: "Speed of the progress animation in milliseconds"
  }
}, _class3.demoProps = {
  color: _providers.DefaultThemingContext.theme.corePrimary,
  minWidth: 500,
  progress: 0.7,
  backgroundColor: _providers.DefaultThemingContext.theme.corePrimaryLightest,
  transitionDurationMs: 800
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = ProgressBar;
exports["default"] = _default;